module.exports = __webpack_public_path__ + "img/CODmn.ef70118c.png";